@if (label) {
  <mat-label [isRequired]="control">{{ label | locale }}</mat-label>
}
<mat-form-field color="accent">
  <input
    matInput
    [formControlName]="controlName"
    [matAutocomplete]="auto"
    [placeholder]="placeholder | locale" />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="optionSelectedEvent.emit($event.option.value)">
    @for (item of items | async; track item) {
      <mat-option
        [value]="item">
        {{ displayFn(item) }}
      </mat-option>
    }
  </mat-autocomplete>

  @if (!control.disabled) {
    <mat-icon
      matIconSuffix
      class="select-suffix"
      (click)="handleClickIcon()"
      [ngClass]="{'icon-available-delete': control?.value}"
      [svgIcon]="control?.value ? 'cancel' : 'short-arrow-down'">
    </mat-icon>
  }

  <mat-error>{{ control | errorMessage }}</mat-error>
</mat-form-field>
